import React from "react";
import { Link } from "react-router-dom";
import { FaHome, FaUser, FaBars } from "react-icons/fa";
import { MdCategory } from "react-icons/md";

function BottomNav() {
  return (
    <div className="fixed bottom-0 left-0 w-full bg-white shadow-md flex justify-around items-center h-16 z-50 border-t">
      <Link to="/" className="flex flex-col items-center text-gray-700 hover:text-black">
        <FaHome size={22} />
        <span className="text-xs mt-1">Home</span>
      </Link>

      <Link to="/categories" className="flex flex-col items-center text-gray-700 hover:text-black">
        <MdCategory size={22} />
        <span className="text-xs mt-1">Categories</span>
      </Link>

      <Link to="/account" className="flex flex-col items-center text-gray-700 hover:text-black">
        <FaUser size={22} />
        <span className="text-xs mt-1">Account</span>
      </Link>

      <Link to="/more" className="flex flex-col items-center text-gray-700 hover:text-black">
        <FaBars size={22} />
        <span className="text-xs mt-1">More</span>
      </Link>
    </div>
  );
}

export default BottomNav;
